import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import WrapperContainer from '../../components/Container/WrapperContainer';
import Button from '../../components/Button/CustomButton';
import GridContainer from '../../components/Grid/GridContainer';
import ProductListOnDisplay from '../../containers/ProductListOnDisplay/ProductListOnDisplay';
import styles from '../../assets/jss/pages/productManagementPageStyle';

const useStyles = makeStyles(styles);

const ProductManagementPreview = ({ eventInfo }) => {
    const classes = useStyles({ eventInfo });
    const params = useParams();
    const history = useHistory();
    const handleClickExitPreview = () => {
        history.push(`/${params.shortName}/product-management`);
    };

    return (
        <WrapperContainer className={classes.wrapper}>
            <GridContainer className={classes.buttonExit}>
                <Button style={{ fontSize: '1.2rem' }} color="info" size="dm" onClick={handleClickExitPreview}>
                    Exit
                </Button>
            </GridContainer>
            <Paper elevation={3} classes={{ root: classes.roomView }}>
                <ProductListOnDisplay />
            </Paper>
        </WrapperContainer>
    );
};

ProductManagementPreview.defaultProps = {
    eventInfo: {},
};

ProductManagementPreview.propTypes = {
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export default ProductManagementPreview;
